import React, { createContext, ReactNode, useContext, useState } from 'react';
import ClockOffAttendanceModal from '../components/clockOffAttendanceModal/ClockOffAttendanceModal';

interface IComponentProps {
  children: ReactNode;
}

const ClockOffAttendanceModalProvider: React.FC<IComponentProps> = function ({ children }) {
  /*
  ** State can be exposed through the private API
  */
  const [showModal, setShowModal] = useState<boolean>(false);
  const [handleDismiss, setHandleDismiss] = useState<() => void | undefined>();

  /*
  ** This method can be exposed through the private API but can only contain
  ** react specific code
  */
  const showClockOffAttendanceModal = (handleDismiss?: () => void) => {
    setShowModal(true);
    setHandleDismiss(() => handleDismiss);
  };

  const hideClockOffAttendanceModal = () => {
    setShowModal(false);
  };

  return (
    <ClockOffAttendanceModalContext.Provider value={
      {
        state: {},
        actions: {
          showClockOffAttendanceModal,
          hideClockOffAttendanceModal,
        }
      }
    }>
      {children}
      <ClockOffAttendanceModal showModal={showModal} handleDismiss={() => {
        setShowModal(false);
        handleDismiss && handleDismiss();
      }} />
    </ClockOffAttendanceModalContext.Provider>
  );
};

export const clockOffAttendanceModalProvider = {
  state: {} as {},
  actions: {} as {
    showClockOffAttendanceModal: (handleDismiss?: () => void) => void,
    hideClockOffAttendanceModal: () => void,
  }
};

/*
** NOTE:
** To use this in react components, use the following code example:
** const { state: {showClockOffModal}, actions: { privateMethod, setShowClockOffModal }} = useClockOffAttendanceModal();
**
** To use this in non-react components, use the following code example:
** clockOffAttendanceModalStatic.publicMethod();
*/

export const ClockOffAttendanceModalContext = createContext<typeof clockOffAttendanceModalProvider>(clockOffAttendanceModalProvider);
export const useClockOffAttendanceModal = () => useContext(ClockOffAttendanceModalContext);

// Expose methods for use in non-react components
export const clockOffAttendanceModalStatic = {};

export default ClockOffAttendanceModalProvider;
